import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { screen } from 'components/styles/variables';

export default function RecommendedPercentage({ percentage }) {
  const { t } = useTranslation();

  return (
    <div className="recommended-percentage-container">
      <div className="percentage">{percentage}%</div>
      <div className="percentage-label">
        {t('dealerPages.recommendThisDealer')}
      </div>
      <style jsx>{`
        .recommended-percentage-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .percentage {
          display: inline-block;
          font-size: 36px;
          line-height: 26px;
          letter-spacing: 0.18px;
          font-weight: 900;
          text-align: center;
          padding-bottom: 15px;
        }

        .percentage-label {
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.2px;
          font-weight: 900;
          text-transform: uppercase;
          text-align: center;
        }

        @media (min-width: ${screen.mdMin}) and (max-width: ${screen.mdMax}) {
          .percentage-label {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
}

RecommendedPercentage.propTypes = {
  percentage: PropTypes.number.isRequired,
};
